import { useState } from "react";
import { MessageCircle, X, Send } from "lucide-react";

const WHATSAPP_NUMBER = "917080800384"; // Amiroop Healthion LLP
const DEFAULT_MESSAGE = "Namaste Healthion India, I would like to know more about your Ayurvedic products.";

export default function WhatsAppButton() {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState(DEFAULT_MESSAGE);

  const buildLink = (text) =>
    `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;

  const quickPrompts = [
    "Which Ashwagandha is best for stress?",
    "Do you deliver to my pincode?",
    "Help me pick products for my Dosha",
    "I want to become a vendor",
  ];

  return (
    <>
      {/* Floating Trigger */}
      <button
        onClick={() => setOpen(true)}
        aria-label="Chat on WhatsApp"
        data-testid="whatsapp-fab"
        className="fixed bottom-6 right-6 z-40 group"
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 animate-ping" />
        <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-2xl border-4 border-white hover:scale-105 transition-transform">
          <MessageCircle className="w-6 h-6" />
        </span>
        <span className="pointer-events-none absolute right-16 top-1/2 -translate-y-1/2 bg-[#1E3A2B] text-white text-xs font-semibold px-3 py-1.5 rounded-full whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity">
          Chat with us
        </span>
      </button>

      {/* Panel */}
      {open && (
        <div className="fixed bottom-24 right-6 z-50 w-[calc(100vw-3rem)] max-w-sm" data-testid="whatsapp-panel">
          <div className="rounded-3xl overflow-hidden shadow-2xl border border-[#E2DDD5] bg-[#FAF8F5]">
            {/* Header */}
            <div className="bg-[#1E3A2B] text-[#FAF8F5] p-4 flex items-start justify-between">
              <div>
                <div className="text-xs font-mono opacity-70">HEALTHION INDIA CARE</div>
                <div className="font-serif text-lg font-semibold mt-0.5">Namaste 🙏</div>
                <div className="text-xs opacity-80 mt-0.5">Typical reply in a few minutes</div>
              </div>
              <button onClick={() => setOpen(false)} className="opacity-70 hover:opacity-100" data-testid="whatsapp-close">
                <X className="w-4 h-4" />
              </button>
            </div>

            {/* Body */}
            <div className="p-4 space-y-3">
              <div className="bg-white border border-[#E2DDD5] rounded-2xl rounded-tl-none p-3 text-sm text-[#1A201C]">
                Hi! How can our Ayurveda care team help you today?
              </div>

              <div className="text-[10px] font-mono uppercase text-[#5A6B5D]">Quick topics</div>
              <div className="flex flex-wrap gap-2">
                {quickPrompts.map((p) => (
                  <button
                    key={p}
                    onClick={() => setMsg(p)}
                    data-testid={`whatsapp-prompt-${p.slice(0, 8).replace(/\s+/g, "-").toLowerCase()}`}
                    className="text-[11px] px-3 py-1.5 rounded-full bg-white border border-[#E2DDD5] hover:border-[#1E3A2B] hover:text-[#1E3A2B]"
                  >
                    {p}
                  </button>
                ))}
              </div>

              <textarea
                value={msg}
                onChange={(e) => setMsg(e.target.value)}
                className="w-full min-h-[80px] border border-[#E2DDD5] rounded-xl p-3 text-sm bg-white outline-[#1E3A2B]"
                placeholder="Type your message..."
                data-testid="whatsapp-message"
              />

              <a
                href={buildLink(msg)}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1FBE5B] text-white font-semibold rounded-full py-3 text-sm transition-colors"
                data-testid="whatsapp-send"
                onClick={() => setTimeout(() => setOpen(false), 500)}
              >
                <Send className="w-4 h-4" /> Continue on WhatsApp
              </a>
              <div className="grid grid-cols-2 gap-2 text-[11px] font-mono">
                <a href="tel:+917080800384" className="text-center bg-white border border-[#E2DDD5] rounded-full py-2 hover:border-[#1E3A2B]" data-testid="whatsapp-call">📞 Call +91 70808 00384</a>
                <a href="mailto:care@healthioindia.com" className="text-center bg-white border border-[#E2DDD5] rounded-full py-2 hover:border-[#1E3A2B]" data-testid="whatsapp-email">✉ Email us</a>
              </div>
              <p className="text-[10px] text-center text-[#5A6B5D] font-mono">Opens WhatsApp with your message pre-filled</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
